import { render, staticRenderFns } from "./login-popup.vue?vue&type=template&id=79a84254&scoped=true"
import script from "./login-popup.vue?vue&type=script&lang=ts"
export * from "./login-popup.vue?vue&type=script&lang=ts"
import style0 from "./login-popup.vue?vue&type=style&index=0&id=79a84254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a84254",
  null
  
)

export default component.exports